var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell"},[_vm._t("default",function(){return [_c('p',[(_vm.value)?_c('span',{staticClass:"val"},[_vm._v(_vm._s(_vm.value))]):_c('span',[_vm._v(" ")]),_vm._v(" "),(_vm.rank && _vm.showRank)?_c('span',{staticClass:"rank"},[_vm._v(_vm._s(_vm.rank)+_vm._s(_vm.ordinal(_vm.rank)))]):_vm._e()])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }